import { render, staticRenderFns } from "./CreateDetail.vue?vue&type=template&id=4162b2de&"
import script from "./CreateDetail.vue?vue&type=script&lang=js&"
export * from "./CreateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CreateDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports